import { Directive, input } from '@angular/core';
import { Textarea } from 'primeng/textarea';

@Directive({
    selector: '[fcpTextarea]',
    standalone: true,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    hostDirectives: [
        {
            directive: Textarea,
            inputs: ['fluid', 'autoResize']
        }
    ]
})
export class FcpTextareaDirective {
    e2e = input<string | null>(null);
}
